import styled from "styled-components"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Grid } from "@mui/material"

export const Gallery = styled(SectionWrapper)`
  padding-top: 0;
  padding-bottom: 1em;
`

export const GridContainer = styled(Grid)`
  ${({ theme }) => theme.breakpoints.up("sm")} {
    height: 600px;
  }

  .MuiGrid-item {
    > div {
      padding: 0.25em;
    }
  }
`

export const Left = styled(Grid)`
  height: 100%;

  > div {
    height: 100%;
  }
`

export const Right = styled(Grid)`
  height: 100%;

  > div {
    height: 50%;
  }
`

export const LeftRev = styled(Grid)`
  height: 100%;

  > div {
    height: 100%;
  }
`

export const RightRev = styled(Grid)`
  height: 100%;

  > div {
    height: 50%;
  }
`
